import Repository from './Repository'
const action = 'statistic'

export default {
  getStatistic() {
    return Repository.get(action)
  },
  getResponsesStatistic() {
    return Repository.post('stats-for-business/flights')
  },
}
